<template>
  <div class="relative w-full h-full overflow-hidden">
    <transition :name="direction">
      <slot />
    </transition>
  </div>
</template>

<script setup lang="ts">
type Props = {
  direction?: 'forward' | 'backward' | 'none'
}

withDefaults(defineProps<Props>(), {
  direction: 'none'
})
</script>

<style scope>
.forward-enter-active,
.forward-leave-active,
.backward-enter-active,
.backward-leave-active {
  transition: transform 0.3s ease;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.forward-enter-active,
.backward-enter-active {
  z-index: 2;
}

.forward-leave-active,
.backward-leave-active {
  z-index: 1;
}

.forward-enter-from {
  transform: translateX(100%);
}

.forward-leave-to {
  transform: translateX(-100%);
}

.forward-enter-to,
.forward-leave-from {
  transform: translateX(0);
}

.backward-enter-from {
  transform: translateX(-100%);
}

.backward-leave-to {
  transform: translateX(100%);
}

.backward-enter-to,
.backward-leave-from {
  transform: translateX(0);
}
</style>
